(function () {
  if (window.howToUseA11y) { return; }

  function stepLine(slide) {
    var txt = slide ? slide.querySelector('.prhow-txt') : null;
    var line = txt ? (txt.innerText || txt.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (line.length > 80) { line = line.slice(0, 80).replace(/\s+\S*$/, '') + '…'; }
    return line;
  }

  window.howToUseA11y = function (sw) {
    if (!sw || !sw.el || sw.el.__htuA11y) { return; }
    sw.el.__htuA11y = true;
    var root = sw.el;
    var total = root.querySelectorAll('.swiper-slide').length;
    if (sw.wrapperEl) { sw.wrapperEl.setAttribute('aria-live', 'off'); }
    if (total < 2) { return; }
    if (!root.getAttribute('role')) { root.setAttribute('role', 'region'); }

    var note = document.createElement('span');
    note.className = 'visually-hidden';
    note.setAttribute('aria-live', 'polite');
    note.setAttribute('aria-atomic', 'true');
    root.appendChild(note);

    function syncInert() {
      Array.prototype.forEach.call(sw.slides, function (slide, i) {
        if (i === sw.activeIndex) {
          if (slide.hasAttribute('inert')) { slide.removeAttribute('inert'); }
        } else if (!slide.hasAttribute('inert')) {
          slide.setAttribute('inert', '');
        }
      });
    }
    syncInert();
    sw.on('slideChange', syncInert);
    sw.on('transitionEnd', syncInert);
    sw.on('loopFix', syncInert);

    var userMoved = false;
    function isControl(target) {
      return !!(target && target.closest && target.closest('.slide-arrow, .swiper-pagination-bullet'));
    }
    root.addEventListener('click', function (e) {
      if (isControl(e.target)) { userMoved = true; }
    }, true);
    root.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && isControl(e.target)) { userMoved = true; }
    }, true);

    sw.on('slideChange', function () {
      if (!userMoved) { return; }
      userMoved = false;
      var line = stepLine(sw.slides[sw.activeIndex]);
      var text = 'Step ' + (sw.realIndex + 1) + ' of ' + total + (line ? ': ' + line : '');
      window.clearTimeout(note.__setTimer);
      window.clearTimeout(note.__clearTimer);
      note.textContent = '';
      note.__setTimer = window.setTimeout(function () {
        note.textContent = text;
        note.__clearTimer = window.setTimeout(function () { note.textContent = ''; }, 3000);
      }, 60);
    });
  };
})();
